import type { I18nProxy, SupportedLocale } from "@peerup/i18n-kit"
import type { App } from "vue"

import { envConfig } from "@peerup/host-env"
import { createI18n, fakeT } from "@peerup/i18n-kit"

import { VITE_APP_VERSION } from "@/config"
import $logger from "@/utils/logger"

// I18nKit 安全代理（实例未初始化时 $t 返回 key 本身）
let proxy: I18nProxy | null = null

export const setupI18n = async (app: App) => {
  const handle = await createI18n({
    localeBasePath: import.meta.env.BASE_URL || "/accounts",
    version: VITE_APP_VERSION,
    projectType: "accounts",
    staticOrigin: envConfig.PRIVATE_PUBLIC_LINK_OFF ? window.location.origin : undefined,
    onLanguageChange: locale => {
      $logger.log("页面刷新", { msg: "监听到切换语言，刷新当前页面", locale }, { immediate: true })
      window.location.reload()
    },
  })

  proxy = handle.proxy
  ;(window as any).i18nKit = handle.instance

  // 注册到 Vue 实例
  app.config.globalProperties.$i18n = handle.instance
  app.config.globalProperties.$t = handle.instance.$t.bind(handle.instance)

  return handle.instance
}

// 为了向后兼容，保留 i18n 导出，但使用 getter 函数
export const i18n: I18nProxy = {
  get $t() {
    return proxy?.$t ?? fakeT
  },
  setLocale: (locale: SupportedLocale) => {
    proxy?.setLocale(locale)
  },
  getCurrentLanguage: () => {
    return proxy?.getCurrentLanguage() ?? "zh-CN"
  },
}
